import identity from 'ramda/src/identity';
import { createActions } from 'redux-actions';
import { updateTrackCueContainerInStore } from 'redux-core/cueContainers/actions';
import { fetchFooterInfo } from 'redux-core/overview/actions';
import { clearancesBundleApi } from 'services/clear/clearances-bundle';
import { updateLicensorCall, updateLicensorFeesCall } from './services';

const actionsDefinition = {
  SET_UPDATE_LETTER_DATE: identity,
  SET_LOADING_UPDATE_LETTER_DATE: identity,
};

export const { setUpdateLetterDate, setLoadingUpdateLetterDate } = createActions(actionsDefinition);

export const setLicensorCall = (payload) => async (dispatch) => {
  dispatch(setLoadingUpdateLetterDate(true));
  try {
    const res = await updateLicensorCall(payload);
    dispatch(setUpdateLetterDate(res));
  } finally {
    dispatch(setLoadingUpdateLetterDate(false));
  }
};

export const copyEstimatedFeesLicensors = (payload) => async (dispatch) => {
  const track = payload;
  let trackUpdatedEstimatedFees = 0;
  let trackUpdatedApprovedFees = 0;
  const licensorsArray = [];
  const trackId = track.id;
    const clearanceBundleId = track.clearancesBundle.id;
  track.clearancesBundle.licensors.forEach((licensor) => {
    const { share } = licensor.rightsOwner;
    licensor.licensors.forEach((l) => {
      licensorsArray.push({
        ...l,
        mfn: l?.mfn ?? 'NONE',
        share,
        trackId,
        recalculateMfn: false,
        clearanceBundleId,
        approvedFees: Number(l.estimatedFees),
      });
    });
  },
  );
  const formattedLicensors = { licensors: licensorsArray };

  // eslint-disable-next-line no-restricted-syntax
  for (const licensor of formattedLicensors.licensors) {
    // eslint-disable-next-line no-await-in-loop
    const response = await updateLicensorFeesCall(licensor);
    const updatedData = response[0];
    if (updatedData) {
      trackUpdatedEstimatedFees = updatedData.trackUpdatedEstimatedFees;
      trackUpdatedApprovedFees = updatedData.trackUpdatedApprovedFees;
    }
  }
  const updatedTrack = {
    ...track,
    estimatedFees: trackUpdatedEstimatedFees,
    approvedFees: trackUpdatedApprovedFees,
  };

  dispatch(
    updateTrackCueContainerInStore(trackId, updatedTrack),
  );

  dispatch(clearancesBundleApi.util.invalidateTags(['clearanceBundle']));
  dispatch(fetchFooterInfo());
};
